export const COGNITO_CODE_REGEX = /code=([^&]+)/;

export const COGNITO_REDIRECT_CODE_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const CORRECT_NUMBER_REGEX = /^[0-9.]*$/;